<template lang="html">

  <form id="formTrabaja" @submit.prevent="validateBeforeSubmit">

    <div class="flex row wrap justify-between">

      <input type="hidden" name="tipo_contacto" value="trabaja">
      
      <div class="contenedor-input middle">
        <input type="text" class="input-text"
        v-model="form.nombre" v-validate="'required'"
        name="nombre" :placeholder="$t('formulario.nombre')+'*'"/>
        <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('nombre') }}</span>
      </div>

      <div class="contenedor-input middle">
        <input type="text" class="input-text"
        v-model="form.apellidos" v-validate="'required'"
        name="apellidos" :placeholder="$t('formulario.apellidos')+'*'"/>
        <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('apellidos') }}</span>
      </div>

      <div class="contenedor-input middle">
        <input type="text" class="input-text"
        v-model="form.email" v-validate="'required|email'"
        name="email" :placeholder="$t('formulario.email')+'*'"/>
        <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('email') }}</span>
      </div>
      
      <div class="contenedor-input middle">
        <input type="text" class="input-text"
        v-model="form.telefono"
        name="telefono" :placeholder="$t('formulario.telefono')"/>
      </div>

      <div class="fecha flex row justify-between">
        <p>{{$t('formulario.fecha_nacimiento')}}</p>
        <div class="select-style">
          <select v-model="form.dia" name="dia">
            <option value="">{{$t('formulario.dia')}}</option>
            <option v-for="d in 31" :value="d">{{d}}</option>
          </select>
        </div>
        <div class="select-style">
          <select v-model="form.mes" name="mes">
            <option value="">{{$t('formulario.mes')}}</option>
            <option v-for="(m, key) in $t('formulario.meses')" :value="key">{{m}}</option>
          </select>
        </div>
        <div class="select-style">
          <select v-model="form.anyo" name="anyo">
            <option value="">{{$t('formulario.anyo')}}</option>
            <option v-for="y in years" :value="y">{{y}}</option>
          </select>
        </div>
      </div>

      <div class="contenedor-input middle">
        <input type="text" class="input-text"
        v-model="form.area_interes"
        v-validate="'required'"
        name="area_interes" :placeholder="$t('formulario.area_interes')+'*'"/>
        <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('area_interes') }}</span>
      </div>

      
      <div class="input-file--container middle">
        <input type="file" @change="setFile" name="doc_adjunto" id="archivo_adjunto">
        <span>{{form.archivo_adjunto}}</span>
      </div>
      

      <div class="working flex row justify-start">
        <p>{{$t('formulario.trabaja_actualmente')}}</p>
        <div class="contenedor-radio">
          <input id="radio3" type="radio" name="activo" value="true" v-model="form.trabaja"/>
          <label for="radio3">{{$t('formulario.si')}}</label>
        </div>
        <div class="contenedor-radio">
          <input id="radio4" type="radio"  name="activo" value="false" v-model="form.trabaja"/>
          <label for="radio4">{{$t('formulario.no')}}</label>
        </div>
      </div>

    </div>
    
    <div class="contenedor-input">
      <textarea :placeholder="$t('formulario.carta_presentacion')+'*'" v-model="form.carta_presentacion"
      name="mensaje" v-validate="'required'"></textarea>
      <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('carta_presentacion') }}</span>
    </div>
    
    <popup-condiciones v-on:launch="showCondiciones" :error="errorCondiciones"></popup-condiciones>

    <div class="contenedor-check contenedor-input"  v-show="condiciones">
      <input id="politica" type="checkbox" v-model="form.politica" name="politica" v-validate="'required'"/>
      <label for="politica">{{$t('formulario.he_leido')}} <router-link target="_blank" :to="$t('enlaces.politica')">{{$t('formulario.y_acepto')}}</router-link>.</label>
      <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('politica') }}</span>
    </div>

    <div class="contenedor-check">
      <input id="otros-procesos" type="checkbox" name="otros-procesos" v-model="form.otros_procesos"/>
      <label for="otros-procesos">{{$t('formulario.otros_procesos')}}</label>
    </div>

    <input type="hidden" name="tipo" value="trabaja">
    
    <button class="btn btn-dark -enviar" :clicked="sending" :sendend="sendend">
      <div class="scroller">
        <span>{{$t('formulario.enviar')}}</span>
        <span>
         <hollow-dots-spinner
         :animation-duration="1000"
         :dot-size="15"
         :dots-num="3"
         color="#054279"
         />
       </span>
       <span>{{$t('formulario.enviado')}}</span>
     </div>
   </button>

 </form>

</template>

<script lang="js">

  import popupCondiciones from '@/components/parts/popup-condiciones'

  import { HollowDotsSpinner } from 'epic-spinners'

  import {mapGetters, mapActions} from 'vuex';

  export default  {
    name: 'formulario',
    props: [],
    mounted(){
      this.form.archivo_adjunto = this.getTexts.formulario.adjuntar_cv;
    },
    components : {
      'popup-condiciones' : popupCondiciones,
      HollowDotsSpinner
    },
    data() {
      return {
       clicked : false,
       sending : false,
       sendend: false,
       condiciones : false,
       form : {
        nombre : '',
        apellidos : '',
        email : '',
        telefono : '',
        dia : '',
        mes : '',
        anyo : '',
        area_interes : '',
        archivo_adjunto : '',
        trabaja : '',
        carta_presentacion: '',
        politica : '',
        otros_procesos : '',
      }
    }
  },
  methods: {
    ...mapActions(['sendTrabajaConNosotros']),
    setFile : function(event){
      this.form.archivo_adjunto = event.target.value;
    },
    showCondiciones : function(){
      this.condiciones = true;
    },
    validateBeforeSubmit : function(){

      this.clicked = true;
      this.$validator.validateAll().then(canSend => {


        if(canSend){
          let data = new FormData(document.getElementById("formTrabaja")); 
          this.sending = true;
          this.sendTrabajaConNosotros(data)
          .then(result =>{
            console.log(result);
            if(result){
              this.sendend = true;
              this.clicked = false;
              for(let i in this.form){
                this.form[i] = '';
              }
              this.form.archivo_adjunto = "Adjuntar CV";
              this.condiciones = false;
            }
          });
        }

      });
    },
  },
  computed: {
    years : function(){

      let date = new Date();
      let actual = date.getFullYear();
      let years = new Array();

      for(var k = actual-70; k <= actual-16; k++){
        years.push(k);
      }

      return years;
    },
    errorCondiciones : function(){
      let flag = (!this.condiciones && this.clicked) ? true : false;
      return flag;
    },
    ...mapGetters(['getServer', 'getLanguage', 'getTexts']),

  }
}
</script>

<style scoped>
.contenedor-input .error{
  bottom: -14px;
}


.select-style.contenedor-input .error{
  bottom: -24px;
}

.contenedor-check.contenedor-input{
  padding-bottom: 10px;
}

.btn.-enviar{
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  margin-top: 50px;
  width: 270px;
  height: 57px;
  padding: 0;
  outline: none;
}

.scroller{
  transition: .4s;
  width: 100%;
}
.btn[clicked="true"] .scroller{
  transform: translateY(-33.333333333%);
}

.btn[sendend="true"] .scroller{
 transform: translateY(-66.6666666666%);
}


.btn span{
  height: 57px;
  line-height: 57px;
  width: 100%;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-align-items: center;
  align-items: center;
  width: 100%;
}

.btn span:last-of-type{
  background: #054279;
  color: #fff;
}

@media screen and (max-width: 768px){
  .contenedor-input.middle{
    width: 100%;
  }
  .fecha{
    -webkit-flex-wrap: wrap;
    -moz-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    -o-flex-wrap: wrap;
    flex-wrap: wrap;
  }

  .cv-form .fecha .select-style{
    width: 33.33333%;
  }

  .cv-form .fecha p{
    width: 100%;
  }

  .input-file--container.middle{
    width: 100%;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/view-parts/trabaja-con-nosotros/formulario.vue